// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-display{transform-origin:bottom left}#messenger-button{left:0px}#messenger-button .cs-number{left:25px}\n", ""]);
// Exports
module.exports = exports;
